export const searchComponent = {
  key: 'searchComponent',
  name: 'Search Component',
  siteIdentifier: 'global',

  title: 'Search Results',
  countOfItems: '{count} items',
  countOfItemsSingular: '{count} item',
  sortByRelevance: 'Relevance',
  sortByPriceLowToHigh: 'Price: Low to High',
  sortByPriceHighToLow: 'Price: High to Low',
  sortByRating: 'Rating',
  sortByBestSelling: 'Best Selling',
  sortByNewest: 'Newest',
  sortByOldest: 'Oldest',
  clearFiltersLabel: 'Clear filters',
  priceLabel: 'Price',
  noResults: 'No Results',
  filterToggleCollapsibleLabel: 'Promotions',
  filterToggleOnSale: 'On Sale',
  filterToggleFreeShipping: 'Free Shipping Eligible',
  ratingsFilterLabel: 'Rating',
  ratingsFilterText: '& Up',
  ratingsFilterTextAriaLabel: '{count} stars and up',
  categoryFilterLabel: 'Category',
  priceRangeFilterLabel: 'Price Range',
  authorFilterLabel: 'Author',
  refinementCountAriaLabel: '{count} items available',
  publishedDateFilterLabel: 'Published Date',
  languageFilterLabel: 'Language',
  refinementCountAriaLabelSingular: '{count} item available',
  filterTagRemovedAriaLabel: 'Remove {tagName} filter',
  noResultsWithQuery: 'No results for {query}',
  noResultsAdviceSpelling: 'Double-check your spelling',
  noResultsAdviceFewerWords: 'Use fewer keywords',
  noResultsAdviceLessSpecific: 'Search for a less specific item',
  showMoreLabel: 'Show more',
  showLessLabel: 'Show less',
};
